export default "__VITE_ASSET__BMzFl0vO__"